import { read } from "./read"

export const project = {
  read,
}
